import React, { useState, useEffect } from 'react';
import { useT } from '../i18n/LanguageContext';
export function UrgencyBanner() {
  const t = useT().urgency;
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 59
  });
  useEffect(() => {
    // Get or set the deadline (24h rolling, persisted in localStorage)
    let deadline: number;
    try {
      const stored = typeof window !== 'undefined' ? window.localStorage.getItem('aib_deadline') : null;
      if (stored && Number(stored) > Date.now()) {
        deadline = Number(stored);
      } else {
        deadline = Date.now() + 24 * 60 * 60 * 1000;
        if (typeof window !== 'undefined') window.localStorage.setItem('aib_deadline', String(deadline));
      }
    } catch (e) {
      deadline = Date.now() + 24 * 60 * 60 * 1000;
    }
    const tick = () => {
      const diff = deadline - Date.now();
      if (diff <= 0) {
        // Reset to another 24h if expired
        const newDeadline = Date.now() + 24 * 60 * 60 * 1000;
        try {
          window.localStorage.setItem('aib_deadline', String(newDeadline));
        } catch (e) {}
        return;
      }
      const hours = Math.floor(diff / (1000 * 60 * 60));
      const minutes = Math.floor(diff % (1000 * 60 * 60) / (1000 * 60));
      const seconds = Math.floor(diff % (1000 * 60) / 1000);
      setTimeLeft({
        hours,
        minutes,
        seconds
      });
    };
    tick();
    const interval = setInterval(tick, 1000);
    return () => clearInterval(interval);
  }, []);
  const pad = (n: number) => n.toString().padStart(2, '0');
  return <div className="sticky top-0 z-50 bg-brand text-black py-2.5 px-4 border-b-2 border-black/10" data-id="element-216">
      <div className="max-w-7xl mx-auto flex items-center justify-center gap-3 sm:gap-4 flex-wrap" data-id="element-217">
        <span className="font-mono text-[10px] sm:text-xs font-bold uppercase tracking-[0.14em]" data-id="element-218">
          🔥 {t.label}
        </span>
        <div className="flex items-center gap-1.5 sm:gap-2" data-id="element-219">
          <span className="font-archivo text-sm sm:text-base bg-black text-brand px-2 py-0.5 rounded" data-id="element-220">
            {pad(timeLeft.hours)}H
          </span>
          <span className="font-archivo text-sm sm:text-base bg-black text-brand px-2 py-0.5 rounded" data-id="element-221">
            {pad(timeLeft.minutes)}M
          </span>
          <span className="font-archivo text-sm sm:text-base bg-black text-brand px-2 py-0.5 rounded" data-id="element-222">
            {pad(timeLeft.seconds)}S
          </span>
        </div>
        <span className="font-mono text-[10px] sm:text-xs font-bold uppercase tracking-[0.14em] hidden sm:inline" data-id="element-223">
          {t.priceNote}
        </span>
      </div>
    </div>;
}